module.exports = __webpack_public_path__ + "img/download.3e7ecc17.svg";